import { apiService } from '../api';
import {
  InventorySummary,
  ValuationRow,
  ConsumptionRow,
  ProfitabilityRow,
  StockMovement,
  InventoryItem,
  ReportFilters,
} from '../../types/inventory';

const BASE = '/inventory/reports';

export const inventoryReportService = {
  async getSummary(org: string, restaurantId?: string): Promise<InventorySummary> {
    const response = await apiService.get<InventorySummary>(`${BASE}/summary`, {
      org,
      ...(restaurantId && { restaurantId }),
    });
    return response.data;
  },

  async getLowStock(org: string, restaurantId?: string): Promise<InventoryItem[]> {
    const response = await apiService.get<InventoryItem[]>(`${BASE}/low-stock`, {
      org,
      ...(restaurantId && { restaurantId }),
    });
    return response.data;
  },

  async getValuation(org: string, restaurantId?: string): Promise<ValuationRow[]> {
    const response = await apiService.get<ValuationRow[]>(`${BASE}/valuation`, {
      org,
      ...(restaurantId && { restaurantId }),
    });
    return response.data;
  },

  async getProfitability(org: string, restaurantId?: string): Promise<ProfitabilityRow[]> {
    const response = await apiService.get<ProfitabilityRow[]>(`${BASE}/profitability`, {
      org,
      ...(restaurantId && { restaurantId }),
    });
    return response.data;
  },

  async getConsumption(filters: ReportFilters): Promise<ConsumptionRow[]> {
    const response = await apiService.get<ConsumptionRow[]>(`${BASE}/consumption`, filters);
    return response.data;
  },

  async getMovements(filters: ReportFilters & { type?: string }): Promise<StockMovement[]> {
    const response = await apiService.get<StockMovement[]>(`${BASE}/movements`, filters);
    return response.data;
  },
};
